<template>
  <div v-loading="cartData.loading" class="lite-product-carts p-1">
    <div v-if="cartCount">
      <template v-for="event in cartEventGroupsFormatted" :key="event.cart_group_key">
        <el-card class="cart-group-item mb-3">
          <template v-if="event.cart_group_name" #header>
            <el-tag v-if="event?.prom_type" type="danger" effect="dark" class="mr-2">
              {{ promotionTypeLabel(event?.prom_type) }}
            </el-tag>
            <span>{{ event.cart_group_name }}</span>
          </template>
          <div>
            <div v-for="(item, idx) in event?.items" :key="idx">
              <el-divider v-if="idx > 0" />
              <div class="d-flex w-full">
                <div class="mr-2 d-flex flex-column" style="width: 60px; min-width: 60px">
                  <cart-quantity-selector
                    v-model="item.quantity"
                    :min="item.min_order_quantity"
                    :max="maxQty(item)"
                    :title="`更新數量 ${item.product_name}`"
                    @change="(val) => changeQty({ cart_id: item.cart_id, quantity: val })"
                  />

                  <a
                    href="javascript:void(0)"
                    :title="`移除 ${item.product_name}`"
                    class="mt-auto mx-auto text-delete-cart"
                    @click="deleteCartWithConfirm(item)"
                  >
                    移除
                  </a>
                </div>
                <div class="d-flex w-full">
                  <div style="min-width: 70px">
                    <a :href="viewCartItem(item)">
                      <el-image
                        :src="imgProxy(item.image_url, (rs = 'fill:62:62:1'))"
                        :alt="item.product_name"
                        style="width: 62px; height: 62px; border: 1px solid #eef6ff"
                        class="rounded"
                      >
                        <template #error> </template>
                      </el-image>
                    </a>
                  </div>

                  <div class="flex-fill">
                    <el-tag
                      v-if="item?.hasErrorStatus"
                      type="danger"
                      effect="dark"
                      size="small"
                      class="mr-1"
                    >
                      {{ item.hasErrorStatus }}
                    </el-tag>

                    <el-tag
                      v-else-if="item?.hasWarningStatus"
                      type="warning"
                      effect="dark"
                      size="small"
                      class="mr-1"
                    >
                      {{ item.hasWarningStatus }}
                    </el-tag>

                    <a :href="viewCartItem(item)">
                      <div style="font-size: 14px">
                        {{ item.product_name }}
                      </div>
                    </a>

                    <div class="d-none d-sm-block">
                      <small class="text-muted" style="font-size: 12px">
                        {{ t("carts.options") }}:
                      </small>
                      <CartAssortSelector
                        :data="item"
                        :store-data="storeData"
                        :dealer="dealerData"
                        :is-subscribe="!!isSubscribe"
                        @change="handleChangeAssort"
                      />
                      <div
                        v-if="!hiddenPrice"
                        class="d-flex flex-wrap align-items-center"
                      >
                        <div class="text-accent mr-2">
                          {{ item.symbol }}
                          {{ n(item.discounted_price * item.quantity) }}
                        </div>
                        <div class="text-muted" style="font-size: 12px">
                          <s>
                            {{ aliasTranslations?.comm_price || $t("carts.commPrice") }}:
                            {{ item.symbol }}
                            {{ n(item.comm_price * item.quantity) }}
                          </s>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-sm-none w-full mt-1">
                <div class="d-flex align-items-center">
                  <small class="text-muted" style="font-size: 12px; min-width: 68px">
                    {{ t("carts.options") }}:
                  </small>
                  <CartAssortSelector
                    :data="item"
                    :dealer="dealerData"
                    :is-subscribe="!!isSubscribe"
                    :store-data="storeData"
                    @change="handleChangeAssort"
                  />
                </div>
                <div
                  v-if="!hiddenPrice"
                  class="d-flex flex-wrap align-items-center justify-content-end"
                >
                  <div class="text-accent mr-2">
                    {{ item.symbol }}
                    {{ n(item.discounted_price * item.quantity) }}
                  </div>
                  <div class="text-muted" style="font-size: 12px">
                    <s>
                      {{ aliasTranslations?.comm_price || $t("carts.commPrice") }}:
                      {{ item.symbol }}
                      {{ n(item.comm_price * item.quantity) }}
                    </s>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </template>
      <div class="cart-summary">
        <div class="d-flex justify-content-between px-1">
          <div class="text-left">
            <div v-if="!hiddenPrice" class="d-flex align-items-end">
              <strong
                class="mr-1 text-black-50"
                style="font-size: 1.5rem; line-height: 1.5rem"
              >
                總金額
              </strong>

              <span class="text-muted">費用</span>
            </div>
            <small class="text-primary">
              {{ t("carts.items", [cartCount]) }}
            </small>
          </div>
          <div v-if="!hiddenPrice">
            <div v-if="!!assortDiscount" class="text-danger">
              {{ t("orders.assortDiscount") }}: -{{ cartData.currency_symbol }}
              {{ $n(assortDiscount) }}
            </div>
            <div v-if="!!promDiscount" class="text-danger">
              {{ t("orders.promDiscount") }}: -{{ cartData.currency_symbol }}
              {{ $n(promDiscount) }}
            </div>
            <strong class="text-black-50" style="font-size: 1.5rem">
              {{ cartData.currency_symbol }}
              {{ $n(subTotal - promDiscount) }}
            </strong>
          </div>
        </div>
        <div class="mt-2">
          <el-button
            v-if="checkAddon"
            type="danger"
            disabled
            size="large"
            class="btn-block large-button"
          >
            <!-- 購物車至少需要一個主要商品 -->
            🚫 無法單獨購買【加購品】 ⛔
          </el-button>
          <el-button
            v-else-if="cartCount > 0"
            type="primary"
            :disabled="!cartCount || checkAddon"
            size="large"
            class="btn-block btn-submit-cart large-button blink-border"
            @click="handleOpenCheckoutDialog()"
          >
            <i class="fa fa-hand-pointer-o mr-2" aria-hidden="true"></i>
            {{ "下一步" }}
          </el-button>
        </div>
      </div>
    </div>
    
    <EmptyCartImage v-else />
  </div>
</template>

<script setup>
import { computed, ref, toRaw } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import {
  breakpoint,
  notificationErrors,
  imgProxy,
  lookupPromotionTypes,
  isBundlePromotionType,
  lookupAliasTranslations,
} from "../../utils";
import CartQuantitySelector from "../checkout/CartQuantitySelector.vue";
import CartAssortSelector from "../checkout/CartAssortSelector.vue";
import EmptyCartImage from "../EmptyCartImage.vue";
import {
  _api_updateCartQty,
  _api_deleteCart,
  _api_getCarts,
  _api_createCart,
  _api_createCartGroup,
} from "../../api/index.js";
import { ElLoading } from "element-plus";

const props = defineProps({
  isBundle: Boolean,
})

const { t, n, locale } = useI18n();

const store = useStore();
const isMobile = computed(() => breakpoint.value.xs || breakpoint.value.sm);
const storeData = computed(() => store.getters["lite/storeData"]);
const hiddenPrice = computed(() => !!storeData.value?.settings?.hidden_price);
const hiddenCart = computed(() => !!storeData.value?.settings?.hidden_cart);
const hiddenContact = computed(() => !!storeData.value?.settings?.hidden_contact);
const aliasTranslations = computed(() =>
  lookupAliasTranslations(storeData.value?.alias_translations, locale.value)
);

const cartCount = computed(() => store.getters["lite/cartCount"]);
const cartData = computed(() => store.getters["lite/cartData"]);
const dealerData = computed(() => store.getters["lite/dealerData"]);
const isSubscribe = computed(() => store.getters["lite/isSubscribe"]);

const checkAddon = computed(() => {
  const disabled = false;
  if (cartData.value?.carts === undefined || !cartData.value?.carts.length) {
    return disabled;
  }
  const hasAddon = cartData.value?.carts.findIndex((el) => el.ptype === "SADDT");
  const hasProd = cartData.value?.carts.findIndex((el) => el.ptype === "SPROD");
  if (hasAddon !== -1 && hasProd === -1) {
    return true;
  }
  return disabled;
});
// 商品折扣
const assortDiscount = computed(() => {
  let total = 0;
  for (const [k, v] of Object.entries(cartEventGroupsFormatted.value)) {
    total += v.assort_discount;
  }
  return formatFloat(total, cartData.value?.currency_point);
});
// 活動折扣
const promDiscount = computed(() => {
  let total = 0;
  for (const [k, v] of Object.entries(cartEventGroupsFormatted.value)) {
    total += v.prom_discount;
  }
  return formatFloat(total, cartData.value?.currency_point);
});
const subTotal = computed(() => {
  let total = 0;
  if (!cartCount.value) {
    return total;
  }
  cartData.value.carts.forEach((cart) => {
    total += cart?.discounted_price * cart?.quantity;
  });
  return total;
});

const promotionMap = computed(() => _.keyBy(cartData.value?.promotions, "id"));

const cartEventGroupsFormatted = computed(() => {
  if (cartData.value?.carts === undefined || !cartData.value?.carts.length) {
    return {};
  }
  // console.debug("cartEventGroupsFormatted: ", cartData.value?.carts)
  var start = new Date().getTime();

  // const cartsCopy = _.cloneDeep(cartData.value.carts)
  const grouped = _.groupBy(cartData.value.carts, (cart) => {
    return cart.event_group ? cart.event_group.event_group_uuid : null;
  });
  hasError.value = false;

  // console.debug("by 活動: ", grouped)
  const formatted = _.reduce(
    grouped,
    (rst, val, key) => {
      // console.debug("key:", key)
      const cartsCopy = _.cloneDeep(val);
      let cart = cartsCopy[0];

      // console.debug("formatted:", cart)
      // let cart_group_name = t("carts.shoppingCart")
      let cart_group_name = "";

      let promotion = null;
      if (key && cart.event_group) {
        promotion = promotionMap.value[cart.event_group.event_id];
        if (promotion) {
          cart_group_name = promotion.title;
          if (
            promotion.min_amount_free_shipping &&
            promotion.min_amount_free_shipping !== null
          ) {
            cart_group_name += " (滿" + promotion.min_amount_free_shipping + "免運)";
          }
        } else {
          cart_group_name = "異常活動";
        }
        cart.event_group["event_name"] = cart_group_name;
      }

      let assort_count = 0; // 組合數量
      let assort_org_total = 0; // 組合 sale_price 總額
      let assort_total = 0; // 組合 discounted_price 總額
      let assort_discount = 0; // 網紅折扣
      let prom_discount = 0; // 活動折扣
      let discountable_store_product_assorts_map = promotion
        ? promotion.discountable_store_product_assorts_map
        : {};
      let choose_gifts = []; // 可選擇贈品
      let choose_gift_qty = 0; // 可選擇贈品數量

      cartsCopy.forEach((cart) => {
        // 只能移除購物車，不支援勾選結帳
        cart.checked = true;
        // 活動價
        if (discountable_store_product_assorts_map[cart.store_assort_id]) {
          cart.discounted_price =
            discountable_store_product_assorts_map[cart.store_assort_id].discounted_price;
        }

        // console.debug("cartEventGroupsFormatted 2:", cart.cart_id, cart.discounted_price)
        if (cart.checked) {
          assort_count += cart.quantity;
          assort_org_total += cart.sale_price * cart.quantity;
          assort_total += cart.discounted_price * cart.quantity;
        }
        cart.hasErrorStatus = hasErrorStatus(cart);
        cart.hasWarningStatus = hasWarningStatus(cart);
        if (!!cart.hasErrorStatus) {
          hasError.value = true;
        }
      });

      assort_discount = assort_org_total - assort_total;

      if (promotion) {
        let prom_discount_info = getPromotionDiscount(
          promotion,
          assort_total,
          assort_count
        );
        if (isBundlePromotionType(promotion?.type)) {
          prom_discount_info = getBundleDiscount(promotion, cartsCopy);
        }

        prom_discount = prom_discount_info.prom_discount;
        choose_gifts = prom_discount_info.choose_gifts;
        choose_gift_qty = prom_discount_info.choose_gift_qty;
        // console.log('prom_discount_info: ', promotion?.type)
      }
      /*
      console.log('===============================')
      console.log('cart_group_name: ', cart_group_name)
      console.log('assort_count: ', assort_count)
      console.log('assort_org_total: ', assort_org_total)
      console.log('assort_total: ', assort_total)
      console.log('assort_discount: ', assort_discount)
      console.log('prom_discount: ', prom_discount)
      console.log('===============================')
      */

      rst[key] = {
        cart_group_key: key,
        cart_group_name: cart_group_name,
        items: cartsCopy,
        count: assort_count,
        assort_org_total: assort_org_total,
        assort_total: assort_total,
        assort_discount: assort_discount,
        prom_discount: prom_discount,
        prom_id: promotion ? promotion.id : null,
        prom_type: promotion ? promotion.type : null,
        choose_gifts: choose_gifts,
        choose_gift_qty: choose_gift_qty,
      };
      // console.debug("eventCart: ", rst[key])

      return rst;
    },
    {}
  );
  // console.debug("formatted: ", formatted)
  // return {}
  var end = new Date().getTime();
  // console.debug("計算 活動: " + (end - start) / 1000 + " sec")
  // handleGroupsFormatted()

  return formatted;
});

const hasError = ref(false); // disabled 結帳按鈕

const hasErrorStatus = (item) => {
  if (item.status == "delete") {
    return t("carts.modelInvalid");
  } else if (item.status == "event_delete") {
    return "異常活動";
  } else if (item.status == "event_lower") {
    return "活動已下架或尚未開始";
  } else if (item.status != "shelves") {
    return t("carts.ProductOff");
  } else if (!item.inventory || !item.max_order_quantity) {
    return "已售完";
  } else if (item.quantity > item.max_order_quantity) {
    return `已超過最大訂購上限 ${item.max_order_quantity}`;
  }
  return null;
};

const promotionTypeLabel = (prom_type) => {
  const list = lookupPromotionTypes();
  const item = list.find((el) => el.value === prom_type);
  if (item) {
    return item.label;
  }
  return prom_type;
};

const hasWarningStatus = (item) => {
  if (item.inventory < 10) {
    return t("carts.ProductRemaining", [item.inventory]);
  }
  return null;
};
// 計算任選數量
const getBundleDiscount = (promotion, carts = []) => {
  let prom_discount = 0; // 活動折扣
  const condition = promotion?.conditions?.[0];
  let obj = {
    prom_discount: formatFloat(prom_discount, cartData.value?.currency_point),
    choose_gifts: [],
    choose_gift_qty: 0,
  };
  if (!promotion || !condition || promotion?.condition_min_type != "qty") return obj;
  let bundles = [];
  let cartsCopy = _.cloneDeep(carts);
  // 1. 排序金額(大到小)
  const sortCart = [...cartsCopy.sort((a, b) => b.discounted_price - a.discounted_price)];

  // 2. 拆解單筆商品數量
  cartsCopy = [];
  // console.debug("sortCart", sortCart)
  sortCart.forEach((cart) => {
    if (cart.checked) {
      for (let i = 0; i < cart.quantity; i++) {
        cartsCopy.push({ ...cart, quantity: 1 });
      }
    }
  });
  // 3. 組合任選條件
  let assort_total = 0,
    discounted_price = 0,
    discount_amount = 0,
    discountable_quantity = 0;
  bundles = _.chunk(cartsCopy, condition?.min_qty);
  for (const bundle of bundles) {
    if (bundle.length != condition?.min_qty) continue;
    // console.debug("bundle", toRaw(bundle))
    bundle.forEach((cart) => {
      assort_total += cart.discounted_price;
    });
    discounted_price += condition?.discounted_price;
    discount_amount += condition?.discount_amount;
    discountable_quantity += condition?.discountable_quantity;
  }
  // console.debug("discount_amount", toRaw(discount_amount))
  const discount_type = promotion?.discount_type;
  let choose_gift_store_product_ids = [];
  if (discount_type == "pricing") {
    // 固定金額
    prom_discount += assort_total - discounted_price;
  } else if (discount_type == "amount") {
    prom_discount = discount_amount;
  } else if (discount_type == "percentage") {
    prom_discount = assort_total * (condition.discount_percentage / 100);
  } else if (discount_type == "gift") {
    choose_gift_store_product_ids = condition.discountable_store_product_ids;
    obj.choose_gift_qty = discountable_quantity;
  }

  const promDiscountableStoreProductMap = _.keyBy(
    promotion.discountable_store_products,
    "id"
  );
  choose_gift_store_product_ids.forEach((store_product_id) => {
    const gift = promDiscountableStoreProductMap[store_product_id.toString()];
    if (gift) {
      obj.choose_gifts.push(gift);
    }
  });
  obj.prom_discount = formatFloat(prom_discount, cartData.value?.currency_point);
  return obj;
};
const getPromotionDiscount = (promotion, assort_total, assort_count) => {
  let prom_discount = 0; // 活動折扣
  let choose_gifts = [];
  let choose_gift_qty = 0;
  let obj = {
    prom_discount: formatFloat(prom_discount, cartData.value?.currency_point),
    choose_gifts: choose_gifts,
    choose_gift_qty: choose_gift_qty,
  };
  if (!promotion) return obj;

  let discount_type = promotion?.discount_type;
  let discount_value = null;
  let choose_gift_store_product_ids = [];

  // console.debug("assort_count", assort_count)
  // console.debug("assort_total", assort_total)
  // console.debug("condition_min_type", promotion.condition_min_type)

  // 滿額
  if (promotion.condition_min_type == "amount") {
    promotion.conditions.forEach((condition) => {
      if (assort_total >= condition.min_amount) {
        if (discount_type == "amount") {
          discount_value = condition.discount_amount;
        } else if (discount_type == "percentage") {
          discount_value = condition.discount_percentage;
        } else if (discount_type == "gift") {
          choose_gift_store_product_ids = condition.discountable_store_product_ids;
          choose_gift_qty = condition.discountable_quantity;
        }
      }
    });
  }
  // 滿件
  else if (promotion.condition_min_type == "qty") {
    promotion.conditions.forEach((condition) => {
      // console.debug("min_qty", condition.min_qty)
      if (assort_count >= condition.min_qty) {
        if (discount_type == "amount") {
          discount_value = condition.discount_amount;
        } else if (discount_type == "percentage") {
          discount_value = condition.discount_percentage;
        } else if (discount_type == "gift") {
          choose_gift_store_product_ids = condition.discountable_store_product_ids;
          choose_gift_qty = condition.discountable_quantity;
        }
      }
    });
  }

  if (discount_type && discount_value) {
    if (discount_type == "amount") {
      prom_discount = discount_value;
    } else if (discount_type == "percentage") {
      prom_discount = assort_total * (discount_value / 100);
    } else if (discount_type == "pricing") {
      // 任選
    }
  }
  // console.debug("prom_discount", prom_discount)
  const promDiscountableStoreProductMap = _.keyBy(
    promotion.discountable_store_products,
    "id"
  );
  choose_gift_store_product_ids.forEach((store_product_id) => {
    const gift = promDiscountableStoreProductMap[store_product_id.toString()];
    if (gift) {
      choose_gifts.push(gift);
    }
  });

  return {
    prom_discount: formatFloat(prom_discount, cartData.value?.currency_point),
    choose_gifts: choose_gifts,
    choose_gift_qty: choose_gift_qty,
  };
};

const handleChangeAssort = async (item) => {
  try {
    if (!item?.cart_id) {
      return
    }
    // 檢查現有購物車是否已有此組合
    const cart = cartData.value?.carts.find(
      (el) =>
        el?.store_product_id === item?.store_product_id &&
        el?.store_assort_id === item?.new_store_assort_id
    );
    // 刪除原先的 cart_id
    await deleteCart(item);
    if (cart) {
      // 更新購物車數量
      console.debug("更新購物車數量: ", props.isBundle)
      let quantity = item.quantity + cart.quantity;
      if (quantity > item?.max_order_quantity) {
        quantity = item?.max_order_quantity;
      } else if (quantity < item?.min_order_quantity) {
        quantity = item?.min_order_quantity;
      }
      await changeQty({
        cart_id: cart.cart_id,
        quantity: quantity,
        isBundle: props.isBundle,
      });
    } else {
      // 加入購物車
      await addToCartByPayload(item);
    }
    updateCart();
  } catch (error) {
    notificationErrors(error);
  }
};

const addToCartByPayload = async (item, redirect = false) => {
  const loading = ElLoading.service({
    lock: true,
    background: "rgba(0, 0, 0, 0.5)",
  });
  const storageName = item?.event_id ? "ADD_TO_CART_GROUP" : "ADD_TO_CART";
  let payload = {};

  try {
    // console.debug("加入購物車: ", item)
    const data = {
      store_product_id: item?.store_product_id,
      store_assort_id: item?.new_store_assort_id,
      quantity: item?.quantity,
      ptype: item?.ptype,
      isBundle: props.isBundle,
    };
    let res = null;
    if (item?.event_id) {
      payload = {
        event_id: item?.event_id,
        event_type: item?.event_type,
        items: [data],
      };
      res = await _api_createCartGroup(payload);
    } else {
      payload = data;
      res = await _api_createCart(payload);
    }

    localStorage.removeItem(storageName);
    const eventID = res?.headers?.["x-request-id"]
      ? cartData.value?.headers?.["x-request-id"]
      : null;
    aibTrackers.addToCart(payload, null, eventID);
    gtmTrackers.addToCart(payload, null, eventID);
    fbqTrackers.addToCart(payload, null, eventID);
    ttqTrackers.addToCart(payload, null, eventID);
    gtagTrackers.addToCart(payload, null, eventID);
    // toastr.success("成功更新購物車", {
    //   closeButton: true,
    //   progressBar: true,
    //   positionClass: 'toast-top-right',
    // });
    // getData()
    updateCartCount();
  } catch (err) {
    // console.error("加入購物車失敗: ", payload)
    if (err?.errors) {
      const { type, msg } = err.errors[0];
      if (type == "RequireLoginError") {
        const temp = { payload: payload, redirect: redirect };
        localStorage.setItem(storageName, JSON.stringify(temp));
      } else {
        localStorage.removeItem(storageName);
      }
    }
    notificationErrors(err);
  } finally {
    loading.close();
  }
};

const deleteCartWithConfirm = (cart) => {
  swal
    .fire({
      title: "確認從購物車移除？",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dd3333",
      cancelButtonColor: "#78909C",
      confirmButtonText: "確認移除",
      cancelButtonText: "按錯了!",
    })
    .then(async (result) => {
      if (result.value === true) {
        const loading = ElLoading.service({
          lock: true,
          background: "rgba(0, 0, 0, 0.5)",
        });
        try {
          const res = await _api_deleteCart(cart.cart_id);
          const eventID = res?.headers?.["x-request-id"]
            ? res?.headers?.["x-request-id"]
            : null;
          aibTrackers.removeFromCart(cart, eventID);
          gtmTrackers.removeFromCart(cart, eventID);
          fbqTrackers.removeFromCart(cart, eventID);
          ttqTrackers.removeFromCart(cart, eventID);
          gtagTrackers.removeFromCart(cart, eventID);
          cartData.value.carts = cartData.value.carts.filter(
            (el) => el.cart_id !== cart.cart_id
          );
          updateCartCount();
          // console.debug("deleteCart: ", cart)
        } catch (error) {
          notificationErrors(error);
        } finally {
          loading.close();
        }
      }
    });
};

const deleteCart = async (cart) => {
  const loading = ElLoading.service({
    lock: true,
    background: "rgba(0, 0, 0, 0.5)",
  });
  try {
    const res = await _api_deleteCart(cart.cart_id);
    const eventID = res?.headers?.["x-request-id"]
      ? res?.headers?.["x-request-id"]
      : null;
    aibTrackers.removeFromCart(cart, eventID);
    gtmTrackers.removeFromCart(cart, eventID);
    fbqTrackers.removeFromCart(cart, eventID);
    ttqTrackers.removeFromCart(cart, eventID);
    gtagTrackers.removeFromCart(cart, eventID);
    cartData.value.carts = cartData.value.carts.filter(
      (el) => el.cart_id !== cart.cart_id
    );
    updateCartCount();
    // console.debug("deleteCart: ", cart)
  } catch (error) {
    notificationErrors(err);
  } finally {
    loading.close();
  }
};

const changeQty = async (cart) => {
  if (cart.quantity === 0) {
    deleteCartWithConfirm(cart);
  } else {
    const loading = ElLoading.service({
      lock: true,
      background: "rgba(0, 0, 0, 0.5)",
    });
    try {
      const isBundle = cart?.isBundle ? cart?.isBundle : false
      console.debug("isBundle", isBundle)
      await _api_updateCartQty(cart.cart_id, cart.quantity, isBundle);
      const index = cartData.value?.carts.findIndex((el) => el.cart_id === cart.cart_id);
      Object.assign(cartData.value.carts[index], cart);
    } catch (error) {
      notificationErrors(error);
    } finally {
      loading.close();
      updateCartCount();
    }
  }
};

const viewCartItem = (cart) => {
  if (!cart?.cart_id) {
    return;
  }
  if (!cart?.event_group) {
    if (window.AIBWebsiteType === "saas") {
      return `/apps/${cart?.store_product_id}`;
    }
    return `/products/${cart?.store_product_id}`;
  } else {
    const promotion = cartData.value?.promotions.find(
      (p) => p.id === cart?.event_group?.event_id
    );
    if (promotion?.id) {
      return promotion?.is_open_group
        ? `/promotion-groups/${promotion.id}`
        : `/promotions/${promotion.id}`;
    }
  }
  return "#";
};

const updateCart = () => {
  store.dispatch("lite/updateCart");
};

const updateCartCount = () => {
  _api_getCarts().then((res) => {
    const newCartCount = res?.count || 0;
    store.commit("lite/setCartCount", newCartCount);
  });
};

const handleOpenCheckoutDialog = () => {
  store.dispatch("lite/openCheckoutDialog");
};

const maxQty = (cart) => {
  // console.debug("maxQty: ", cart)
  if (cart?.max_order_quantity >= cart?.inventory) {
    return cart?.inventory;
  }
  return cart?.max_order_quantity;
};
</script>

<style lang="scss" scoped>
.lite-product-carts {
  .text-delete-cart {
    font-size: 0.8rem;
  }

  .btn-submit-cart {
    font-size: 1.3rem;
  }

  .el-button.large-button {
    padding: 12px 30px;
    font-size: 20px;
    border-radius: 8px;
    min-height: 50px;
  }

  .btn-submit-cart.blink-border {
    animation: blink-border 1.5s infinite;
  }

  @keyframes blink-border {
    0% {
      border: 5px solid transparent;
    }

    50% {
      border: 5px solid var(--secondary_color);
      color: var(--secondary_color);
    }

    100% {
      border: 5px solid transparent;
    }
  }
}
</style>
